// extracted by mini-css-extract-plugin
export default {"navButton":"styles_navButton__OvZwB","navButtonDisabled":"styles_navButtonDisabled__D4DrQ"};